define([
  'es6!sumo/util',
  'immutable',
  'es6!launcher/actions/ListBuilderActions',
], (Util, Immutable, Actions) => {
  const initialState = Immutable.Map({
    overall: Immutable.Map(),
    byId: Immutable.Map(),
    download: Immutable.Map(),
    loading: false,
  });

  const actionHandlers = {};

  actionHandlers[Actions.ERROR_STATS] = (state, action) => {
    let retState = state.setIn(['overall', action.period], Immutable.fromJS({ error: action.error }));
    retState = retState.set('loading', false);
    return retState;
  };

  actionHandlers[Actions.RECEIVE_DOWNLOAD_PROGRESS] = (state, action) => (
    state.setIn(['download'], Immutable.fromJS(action.status))
  );

  actionHandlers[Actions.REQUEST_STATS] = state => state.set('loading', true);

  actionHandlers[Actions.RECEIVE_STATS] = (state, action) => {
    const retState = state.set('loading', false);

    return retState.setIn(['overall', action.period, action.objectId || 'all'], Immutable.fromJS(action.data));
  };

  actionHandlers[Actions.RECEIVE_TEST_STATS] = (state, action) => {
    const retState = state.set('loading', false);
    return retState.setIn(['byId', action.test_id], Immutable.fromJS(action.data));
  };

  return Util.createReducer(initialState, actionHandlers);
});
